import { render, staticRenderFns } from "./PdpProductHeader.vue?vue&type=template&id=88cf4ff6&"
import script from "./PdpProductHeader.vue?vue&type=script&lang=js&"
export * from "./PdpProductHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports